import gql from "graphql-tag"

export const DELETE_LEDYER_CONFIG = gql`
  mutation deleteLedyerConfig($id: ID!) {
    deleteLedyerConfig(id: $id) {
      status
    }
  }
`
